import { Box } from "@mui/material";

import { ISearchUser } from "../../interfaces";
import NavigationBar from "../../components/navigationBar";
import AppBarPost from "../../components/appBarPost";
import { User } from "../../types";
import UserListItem from "../../components/usersListItem";

const MobileView: React.FC<ISearchUser> = ({
  isMobile,
  state,
  users,
  goToProfile,
}) => {
  return (
    <Box
      style={{
        height: "100vh",
        backgroundColor: "#F3F6F9",
      }}
    >
      <AppBarPost
        isMobile={isMobile}
        state={state}
        onCreatePost={console.log}
        page="users"
      />
      <Box style={{ padding: 8 }}>
        {users.map((el: User) => (
          <UserListItem
            isShowButtom={state.user?._id === el._id ? false : true}
            goToProfile={goToProfile}
            handleFollow={console.log}
            handleUnfollow={console.log}
            isMobile={isMobile}
            isFollow={
              !!state.user?.follows.find((item: string) => item === el?._id)
            }
            user={el}
            key={el._id}
          />
        ))}
      </Box>
      <NavigationBar isMobile={isMobile} state={state} />
    </Box>
  );
};

export default MobileView;
